import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMasterPresenceRepresentative } from "../../../../../models/resources/master/IPresenceRepresentative";

export interface IMasterPresenceRepresentativeListState {
    list?: IMasterPresenceRepresentative[];
    loading: boolean;
}

const initialState: IMasterPresenceRepresentativeListState = {
    loading: false,
};

export const masterPresenceRepresentativeList = createSlice({
    name: "masterOrganismList",
    initialState,
    reducers: {
        resetMasterPresenceRepresentativeList: () => initialState,
        setLoadingMasterPresenceRepresentativeList: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMasterPresenceRepresentativeList: (state, action: PayloadAction<IMasterPresenceRepresentative[]>) => {
            state.list = action.payload;
        },
    },
});

export const { resetMasterPresenceRepresentativeList, setLoadingMasterPresenceRepresentativeList, setMasterPresenceRepresentativeList } =
    masterPresenceRepresentativeList.actions;

export default masterPresenceRepresentativeList.reducer;
